@for (comment of comments; track comment) {
	@let display = toDisplayComment(comment);
	@let hasRole = display.candidateRole === CANDIDATE_ROLE.PF || display.candidateRole === CANDIDATE_ROLE.PM;
	<div class="mb-2 grid grid-cols-6 last:mb-0 lg:grid-cols-4" [class.uppercase]="uppercase">
		<div>
			<span>
				@if (hasRole) {
					[
					@if (display.candidateRole === CANDIDATE_ROLE.PF) {
						<span class="text-purple-90">PF</span>
					}
					@if (display.candidateRole === CANDIDATE_ROLE.PM) {
						<span class="text-purple-90">PM</span>
					}
					]
				}
				<span [class.ml-1]="hasRole">{{ display.maneuver }}</span>
			</span>
		</div>
		<div>
			@if (display.ob !== "TEM" && display.ob !== "REPEAT") {
				@if (display.isReset || display.lastActionDisabled || display.isDisabled) {
					<span class="text-yellow">{{ display.ob }}</span>
				} @else {
					<span [class.text-green]="display.action" [class.text-red]="display.action === false">
						{{ display.ob }}
					</span>
				}
			}
			@if (display.ob === "TEM") {
				<span
					[class.text-green]="(display.rate ?? 0) > 1"
					[class.text-red]="(display.rate ?? 0) <= 1"
					[class.text-yellow]="(display.rate ?? 0) === -1"
				>
					{{ display.maneuver }} {{ display.ob }}
				</span>
			}
			@if (display.ob === "REPEAT") {
				<span class="text-yellow">
					{{ display.ob }}
				</span>
			}
			@if (display.ob !== "TEM" && display.ob !== "REPEAT") {
				@if (display.isReset) {
					<span class="text-yellow">{{ "{ Undo }" }}</span>
				} @else if (display.lastActionDisabled) {
					<span class="text-yellow">{{ "{ Undo N/A }" }}</span>
				} @else if (display.isDisabled) {
					<span class="text-yellow">{{ "{ N/A }" }}</span>
				} @else if (display.action != null) {
					<span [class.text-green]="display.action" [class.text-red]="!display.action">
						{{ display.action ? "{ added }" : "{ removed }" }}
					</span>
				}
			}
			@if (display.ob === "TEM") {
				<span
					[class.text-green]="(display.rate ?? 0) > 1"
					[class.text-red]="(display.rate ?? 0) <= 1"
					[class.text-yellow]="(display.rate ?? 0) === -1"
				>
					{{ "{ " + display.remarks + " }" }}
				</span>
			}
		</div>
		@if (!display.isReset && !display.lastActionDisabled && !display.isDisabled) {
			<span class="col-span-4 break-words lg:col-span-2">{{ display.instructorComment }}</span>
		}
	</div>
}
